import { api } from '@core/api/apiClient';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface PartnerSlot {
  hour: string;
  type: string;
}

export interface PartnerAvailabilityEntry {
  availability: Array<{
    hours: {
      center: {
        slots: PartnerSlot[];
      };
    };
  }>;
}

/** API returns partners keyed by their restaurant ID */
export type PartnerAvailabilityResponse = Record<string, PartnerAvailabilityEntry>;

// ---------------------------------------------------------------------------
// API
// ---------------------------------------------------------------------------

/**
 * Fetch partner availability for a given restaurant, party size, service type, and date.
 * GET /api/partners-availability/{restaurantId}/{partySize}/{serviceType}/{date}
 */
export async function fetchPartnerAvailability(
  restaurantId: number,
  partySize: number,
  serviceType: string,
  date: string,
): Promise<PartnerAvailabilityResponse> {
  return api.get<PartnerAvailabilityResponse>(
    `/api/partners-availability/${restaurantId}/${partySize}/${serviceType}/${date}`,
  );
}
